import countBy from 'lodash/countBy';
import range from 'lodash/range';

export const calculateBinWidthFromOutputs = (outputs, outputsMin, outputsMax) => {
  // Calculate PTP range.
  // TODO: Does ptp calculation need bigmath support?
  const ptp = outputsMax - outputsMin;

  // Auto-calculate the bin size according to sqrt algorithm.
  return ptp / Math.sqrt(outputs.length);
}

export const autoGenerateBucketsFromOutputs = (outputs, autoBinWidth, outputsMin, outputsMax) => {
  // Calculate width of maximum UI-safe bin width
  const maxNumberOfBins = 50;
  const minimumSafeBinWidth = (outputsMax - outputsMin) / maxNumberOfBins;

  // Create x-axis array of bins
  return range(outputsMin, outputsMax, Math.max(autoBinWidth, minimumSafeBinWidth))
}

export const getSortedCountsFromAutoBuckets = (outputs, autoBuckets) => {
  // Step 7: Aggregate count over bin range
  const bucketCounts = countBy(outputs, out => autoBuckets.find((x, i) => {
    if (i + 1 >= autoBuckets.length) return x;
    return out >= x && out < autoBuckets[i + 1];
  }))

  return autoBuckets.map(x => bucketCounts[x]);
}
